import { showToast } from 'common/ToastMessage'
import { Props, RateGenerationToast } from 'screens/ProseEdit/components/RateGenerationToast/RateGenerationToast'
import { message } from 'antd'

export const showRateGenerationToast = (
  { generationId, theme, variant, ...rest }: Omit<Props, 'onClose'>,
  durationInSeconds: number = 10,
) => {
  const dismiss = message.destroy

  showToast(
    <RateGenerationToast generationId={generationId} theme={theme} variant={variant} onClose={dismiss} {...rest} />,
    durationInSeconds,
    String(generationId),
  )

  return dismiss
}
